import Controller from "./companies.controller";
import template from "./companies.html";

const companies = {
  template,
  controller: Controller,
};

export default companies;



// WEBPACK FOOTER //
// ./src/pages/companies/companies.component.js